// extracted by mini-css-extract-plugin
module.exports = {"gallery-container":"Gallery_gallery-container__wy0dw","loading__overlay":"Gallery_loading__overlay__oSFng"};